<template>
  <div>
<div >

      <v-img class="image" width="10em" src="../../assets/confirmation.gif" />
</div>
  
    <v-layout>
      <v-flex class="done-text text-center mb-0"> FEITO! </v-flex>
    </v-layout>
    <v-layout class="subtext pt-1 ">
      <v-flex >
        Seu cadastro foi realizado com sucesso!
        <br>
         Agora aguarde a aprovação do
        administrador do seu condomínio para fazer o login.
      </v-flex>
    </v-layout>
    <v-layout >
        <v-flex class="pb-5 check-step">
            <v-icon v-if="registered" class="check">mdi-check-circle-outline</v-icon>
            <v-icon  v-else >mdi-circle-outline</v-icon>
            Cadastro realizado
        </v-flex>
    </v-layout>
     <v-layout >
        <v-flex class="check-step mb-3">
            <v-icon v-if="approved" class="check">mdi-check-circle-outline</v-icon>
            <v-icon v-else>mdi-circle-outline</v-icon>
            
            Aguardando aprovação do síndico
        </v-flex>
    </v-layout>

    <v-layout>
      <v-flex class="text-center my-3">
        <v-btn large rounded @click="back" class="button white--text ">
          entendido
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
          registered : true,
          approved : false
    };
  },
  methods: {
    back() {
      this.$router.push("/");
    },
  },
};
</script>
<style>
.check {
color: var(--secondary-color) !important;
}
.button {
  background-color: var(--secondary-color) !important;
}
.done-text {
    color: #2E2E2E;
  font-weight: 700;
  font-size: 24px;
}
.subtext {
  padding-left: 1.7em;
  padding-right: 1em;
  padding-bottom: 108px;
}
.check-step{
    padding-left: 2em;
}
.image{
  display: block;
  margin-top: 15px;
  margin-left: auto;
  margin-right: auto;
}

</style>